export default{
  "Mute Video": "Silenciar Vídeo",
  "HitPaw Online Mute Video": "Silenciar Vídeo Online com HitPaw",
  "Fast and easy to remove sound from your video online": "Remover áudio de vídeo online rápido e facilmente",
  "Muting": "Silenciando",
  "Mute Failed": "Falha em silenciar",
  "Mute New": "Silenciar Novo"
};